import { di } from "@/client/di/di";

export const CheckoutForm = di.resolve_core("PaymentsCheckoutForm");
